import { render } from "./BuyerChat.vue?vue&type=template&id=6fa7d210&scoped=true"
import script from "./BuyerChat.vue?vue&type=script&lang=js"
export * from "./BuyerChat.vue?vue&type=script&lang=js"

import "./BuyerChat.vue?vue&type=style&index=0&id=6fa7d210&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa7d210"]])

export default __exports__